const getDocument = (store, documentName) => {
  const document = store.workspace.documents[documentName];
  if (!document) {
    return;
  }
  return document;
};
export {
  getDocument
};
//# sourceMappingURL=helpers.js.map
